<template>
  <div class="riesgo">
    <el-dialog
      append-to-body
      title="Nuevo Riesgo"
      :top="
        (!standard_risk_found && srrChecked) || editRisk === true
          ? '3vh'
          : '30vh'
      "
      :visible.sync="visibleSync"
      width="90%"
      :before-close="cleanDialogLogicData"
    >
      <div>
        <h4>{{ $t("DATOS DEL RIESGO") }}</h4>
        <el-form @keydown.native.enter.prevent>
          <el-row :gutter="20">
            <el-col :span="!standard_risk_found && srrChecked ? 14 : 24">
              <el-form-item
                :label="$t('Nombre del Riesgo o Aspecto ambiental')"
              >
                <center v-if="srrLoading">
                  <br />
                  <br />
                  <Circle9 style="margin-bottom: 8px"></Circle9>
                  <small>Cargando Datos ...</small>
                  <br />
                  <br />
                </center>
                <div v-else>
                  <br>
                  <div v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'">
                    <el-input
                      v-if="custom_name"
                      style="width: 100%; margin-right: 20px;"
                      v-model="risk.nombre"
                      placeholder="Nombre del riesgo"
                    />
                    <el-select type="small" @change="resetDescripcion" :class="{ intermitente: !custom_name }" v-else v-model="risk.nombre" placeholder="Seleccione una opción" style="width: 95%; margin-right: 20px;">
                      <el-option
                        v-for="item in listado_nombres"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-switch
                      @change="resetName()"
                      style="margin-top: 20px;"
                      v-model="custom_name"
                      active-text="Personalizado"
                      inactive-text="Predefinido">
                    </el-switch>

                    <i @click="showInfo = !showInfo" class="el-icon-question" style="position: relative; top: 13px; cursor: pointer;"></i>
                    <el-alert
                      v-if="showInfo === true"
                      style="margin-top: 20px; "
                      title="Información"
                      type="info"
                      >
                      <p style="line-height: 20px;">
                        Este campo contiene un <b>selector</b> con 2 opciones “<b>Predefinido</b>” y “<b>Personalizado</b>” con el fin de generar 
                        el <b>nombre</b> del riesgo o aspecto ambiental que desea crear, ambas opciones se definen de la siguiente manera:
                        <br><br>
                        <b>Predefinido</b>: Esta opción el coordinador puede acceder a una lista con todos los nombres de riesgos o aspectos ambientales 
                        estandarizados por BHP en la actualidad.
                        <br><br>
                        <b>Personalizado</b>: Esta opción permite al usuario coordinador definir un nombre personalizado para el riesgo o aspecto 
                        ambiental. Esto significa que es un riesgo (nuevo) que <b>no se encuentra en la lista de nombres de riesgos o aspectos 
                        ambiental estandarizados por BHP.</b>
                      </p>
                    </el-alert>
                  </div>
                  <div v-else>
                    <el-input
                      style="width: 100%;"
                      v-model="risk.nombre"
                      placeholder="Nombre del riesgo"
                    />
                  </div>
                </div>
                <p
                  v-if="standard_risk_found"
                  style="line-height: normal !important"
                >
                  {{ standard_risk_message }}
                </p>
                <div v-if="!noStandardRiskLeft && standard_risk_found">
                  <div
                    v-for="standard_risk in standard_risks"
                    :key="standard_risk.name"
                    style="line-height: normal !important"
                  >
                    <label>
                      <input
                        type="radio"
                        name="standard_risks"
                        :value="standard_risk.id"
                        v-model="formCustomRisk.standardRisk"
                        @change="enableStandardRiskButton"
                      />
                      {{ standard_risk.name }}
                    </label>
                  </div>
                </div>
                <div v-if="noStandardRiskLeft && standard_risk_found">
                  <ul
                    v-for="standard_risk in standard_risks_original"
                    :key="standard_risk.name"
                  >
                    <li>{{ standard_risk.name }}</li>
                  </ul>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                v-if="!standard_risk_found && srrChecked"
                :label="$t('Tipo de Impacto')"
              >
                <br />
                <el-button-group>
                  <el-button
                    type="info"
                    :plain="risk.tipo && risk.tipo.toLowerCase() !== 'salud'"
                    @click="setTypeRisk('salud')"
                  >
                    <b>Salud</b>
                  </el-button>
                  <el-button
                    type="info"
                    :plain="
                      risk.tipo && risk.tipo.toLowerCase() !== 'seguridad'
                    "
                    @click="setTypeRisk('seguridad')"
                  >
                    <b>Seguridad</b>
                  </el-button>
                  <el-button
                    type="info"
                    :plain="
                      risk.tipo && risk.tipo.toLowerCase() !== 'medioambiente'
                    "
                    @click="setTypeRisk('medioambiente')"
                  >
                    <b>Medioambiente</b>
                  </el-button>
                </el-button-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-if="!standard_risk_found && srrChecked">
        <hr
          class="separacion"
          v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'"
        />
        <div v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'">
          <h4>{{ $t("INFORMACIÓN MEDIOAMBIENTAL") }}</h4>
          <el-form>
            <el-row :gutter="20">
              <el-col :md="12">
                <el-form-item :label="$t('Responsable')">
                  <el-input
                    v-model="risk.medioambiente.responsable"
                    :placeholder="$t('Ingrese responsable')"
                    v-if="editable"
                  />
                  <div v-else>{{ risk.medioambiente.responsable }}</div>
                </el-form-item>
                <el-form-item :label="$t('Condición')">
                  <el-select
                    v-model="risk.medioambiente.condicion"
                    v-if="editable"
                    :placeholder="$t('Seleccione condicion')"
                    class="full-width"
                  >
                    <el-option
                      v-for="item in optionsCondicion"
                      :key="item.value"
                      :label="item.value"
                      :value="item.value"
                    />
                  </el-select>
                  <div v-else>{{ risk.medioambiente.condicion }}</div>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item :label="$t('Evento')">
                  <el-input
                    v-model="risk.medioambiente.evento"
                    :placeholder="$t('Ingrese evento')"
                    v-if="editable"
                  />
                  <div v-else>{{ risk.medioambiente.evento || "N/A" }}</div>
                </el-form-item>
                <el-form-item :label="$t('Equipo Crítico')">
                  <el-input
                    v-model="risk.medioambiente.equipo"
                    :placeholder="$t('Ingrese equipo')"
                    v-if="editable"
                  />
                  <div v-else>{{ risk.medioambiente.equipo || "N/A" }}</div>
                </el-form-item>
                <el-form-item
                  v-if="!editable"
                  :label="$t('Evaluación Aspecto Ambiental')"
                >
                  <el-tag
                    :type="getFactores(risk)[0].mfl >= 3 ? 'danger' : 'success'"
                  >
                    {{
                      getFactores(risk)[0].mfl >= 3
                        ? $t("Significativo")
                        : $t("No Significativo")
                    }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <hr class="separacion" />
        <div>
          <el-row :gutter="30">
            <el-col :md="24">
              <el-col :md="24" v-if="risk.escenario !== ''">
                <br />
                <h4 class="margin-title">{{ $t("ESCENARIO") }}</h4>
                <el-input
                  v-model="risk.escenario"
                  v-if="editable"
                  type="textarea"
                  :rows="6"
                  :placeholder="$t('Ingrese descripción de escenario')"
                />
                <p v-else>{{ risk.escenario || $t("No ingresado") }}</p>
                <br />
                <br />
              </el-col>
              <el-col :md="12">
                <br />
                <h4 class="margin-title">
                  {{ $t("ESCENARIO RESIDUAL") }}
                  <el-popover
                    class="help-box"
                    placement="top"
                    :title="$t('Escenario')"
                    width="200"
                    trigger="hover"
                    :content="
                      $t(`Corresponde a la descripción del evento de riesgo que se
                      está analizando considerando que los controles preventivos son efectivos.`)
                    "
                  >
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </h4>
                <el-input
                  v-model="risk.escenario_residual"
                  v-if="editable"
                  type="textarea"
                  :rows="6"
                  :placeholder="$t('Ingrese descripción de escenario')"
                />
                <p v-else>
                  {{ risk.escenario_residual || $t("No ingresado") }}
                </p>
                <br />
                <br />
              </el-col>
              <el-col :md="12">
                <br />
                <h4 class="margin-title">
                  {{ $t("ESCENARIO MFL") }}
                  <el-popover
                    class="help-box"
                    placement="top"
                    :title="$t('Escenario MFL')"
                    width="200"
                    trigger="hover"
                    :content="
                      $t(`Corresponde a la descripción del evento de riesgo que se está
                      analizando considerando que los controles preventivos son inefectivos o
                      inexistentes.`)
                    "
                  >
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </h4>
                <el-input
                  v-model="risk.escenario_mfl"
                  v-if="editable"
                  type="textarea"
                  :rows="6"
                  :placeholder="$t('Ingrese descripción de escenario')"
                />
                <p v-else>{{ risk.escenario_mfl || $t("No ingresado") }}</p>
                <br />
                <br />
              </el-col>
            </el-col>
          </el-row>
        </div>
        <hr class="separacion" />
        <div class="box-card">
          <el-row :gutter="20">
            <!-- Causas -->
            <el-col :md="10">
              <br />
              <h4 class="left margin-title">
                {{ $t("CAUSAS") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  :title="$t('Causas')"
                  width="200"
                  trigger="hover"
                  :content="
                    $t(
                      'Las causas son las circunstancias que pueden gatillar la ocurrencia del evento.'
                    )
                  "
                >
                  <i slot="reference" class="el-icon-question" />
                </el-popover>
              </h4>
              <el-button
                v-if="editable"
                icon="el-icon-plus"
                type="primary"
                size="mini"
                class="right"
                @click="dialogNewCausaVisible = true"
              >
                <b>{{ $t("Añadir Causa") }}</b>
              </el-button>
              <el-table
                :data="risk.causas"
                style="width: 100%"
                :key="componentKey"
                row-class-name="rowClassTablaPloma"
                header-cell-class-name="header-cell-class-table-gray-2"
              >
                <el-table-column prop="id" label="ID" width="80">
                  <template slot-scope="scope"
                    >CA{{ risk.causas.indexOf(scope.row) + 1 }}</template
                  >
                </el-table-column>
                <el-table-column prop="nombre" :label="$t('Nombre')" />
                <el-table-column
                  v-if="editable"
                  align="center"
                  header-align="center"
                  width="125"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="small"
                      @click="editDialogCausa(scope.row)"
                      icon="el-icon-edit"
                    />
                    <el-button
                      type="danger"
                      size="small"
                      @click="deleteCausa(scope.row)"
                      icon="el-icon-delete"
                    />
                  </template>
                </el-table-column>
              </el-table>
              <br />
            </el-col>
            <!-- Riesgo -->
            <el-col :md="4">
              <!-- COLORES
              Material rojo
              No material amarillo
              Custom celeste-->
              <!-- Riesgo Material creado por MEL desde admin -->
              <div
                v-if="risk.tipo && risk.tipo.toLowerCase() === 'salud'"
                class="colorSalud customRiskBox"
              >
                {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
              </div>
              <!-- Riesgo No Material creado por MEL desde admin -->
              <div
                v-if="risk.tipo && risk.tipo.toLowerCase() === 'seguridad'"
                class="colorSeguridad customRiskBox"
              >
                {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
              </div>
              <!-- Riesgo Personalizado -->
              <div
                v-if="
                  risk.tipo &&
                  (risk.tipo.toLowerCase() === 'medioambiental' ||
                    risk.tipo.toLowerCase() === 'medioambiente')
                "
                class="colorMedioambiental customRiskBox"
              >
                {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
              </div>
              <!-- Riesgo Sin tipo -->
              <div
                v-if="risk.tipo === null"
                class="colorWithoutRisk customRiskBox"
              >
                {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
              </div>
            </el-col>
            <!-- Impactos -->
            <el-col :md="10">
              <br />
              <h4 class="left margin-title">
                {{ $t("IMPACTOS") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  :title="$t('Impactos')"
                  width="200"
                  trigger="hover"
                  :content="$t(`Nivel de severidad cuando el evento ocurre.`)"
                >
                  <i slot="reference" class="el-icon-question" />
                </el-popover>
              </h4>
              <el-button
                v-if="editable && risk.impactos < 1"
                icon="el-icon-plus"
                size="mini"
                type="primary"
                class="right"
                :class="!risk.tipo && 'button-disabled'"
                :disabled="!risk.tipo"
                @click="dialogNewImpactoVisible = true"
              >
                <b>{{ $t("Evaluar Impacto") }}</b>
              </el-button>
              <el-table
                :data="risk.impactos"
                style="width: 100%"
                row-class-name="rowClassTablaPloma"
                header-cell-class-name="header-cell-class-table-gray-2"
              >
                <el-table-column prop="id" label="ID" width="80">
                  <template slot-scope="scope"
                    >IM{{ risk.impactos.indexOf(scope.row) + 1 }}</template
                  >
                </el-table-column>
                <el-table-column prop="categoria" :label="$t('Tipo')" />
                <el-table-column prop="mfl" label="MFL" />
                <el-table-column prop="factor_severidad" label="FS" />
                <el-table-column prop="factor_probabilidad" label="FP" />
                <el-table-column prop="nivel_severidad" label="NSR" />
                <el-table-column
                  v-if="editable"
                  align="center"
                  header-align="center"
                  width="125"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="small"
                      icon="el-icon-edit"
                      @click="editDialogImpacto(scope.row)"
                    />
                    <el-button
                      type="danger"
                      size="small"
                      icon="el-icon-delete"
                      @click="deleteImpacto(scope.row)"
                    />
                  </template>
                </el-table-column>
              </el-table>
              <br />
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row :gutter="20">
            <!-- Controles Preventivos -->
            <el-col :md="10">
              <hr />
              <br />
              <h4 class="left margin-title">
                {{ $t("CONTROLES PREVENTIVOS") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  :title="$t('Controles Preventivos')"
                  width="200"
                  trigger="hover"
                  :content="
                    $t(`Los controles preventivos son los que se
                    utilizan para enfrentarse a las causas, por lo que reducen
                    la probabilidad de que ocurran riesgos.`)
                  "
                >
                  <i slot="reference" class="el-icon-question" />
                </el-popover>
              </h4>
              <el-button
                v-if="
                  editable && risk.causas.length > 0 && risk.impactos.length > 0
                "
                icon="el-icon-plus"
                class="right"
                type="primary"
                size="mini"
                @click="dialogNewControlPreventivoVisible = true"
              >
                <b>{{ $t("Añadir Control Preventivo") }}</b>
              </el-button>
              <el-table
                row-class-name="rowClassTablaPloma"
                header-cell-class-name="header-cell-class-table-gray-2"
                :key="componentKey"
                :data="getControlesPreventivos(risk)"
                style="width: 100%"
              >
                <el-table-column prop="nombre" :label="$t('Nombre')" />
                <el-table-column
                  prop="id_causa"
                  :label="$t('Causa')"
                  width="90"
                >
                  <template slot-scope="scope">
                    <div
                      v-for="causaHumanID in scope.row.causasHumanID"
                      :key="causaHumanID"
                    >
                      {{ causaHumanID }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="editable"
                  align="center"
                  header-align="center"
                  width="125"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="small"
                      @click="editDialogControlPreventivo(scope.row)"
                      icon="el-icon-edit"
                    />
                    <el-button
                      type="danger"
                      size="small"
                      @click="deleteControlPreventivo(scope.row)"
                      icon="el-icon-delete"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <!-- Factores -->
            <el-col :md="4">
              <h4 class="align-center">{{ $t("FACTORES") }}</h4>
              <el-table
                :data="getFactores(risk)"
                style="width: 100%"
                class="factores"
              >
                <el-table-column prop="rrr" align="center" label="RRR">
                  <template slot-scope="scope">
                    <el-tag class="factores">{{ scope.row.rrr }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="mfl" align="center" label="MFL">
                  <template slot-scope="scope">
                    <el-tag
                      v-bind:type="mflRange(scope.row.mfl)"
                      class="factores"
                      hit
                      >{{ scope.row.mfl }}</el-tag
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <!-- Controles Mitigadores -->
            <el-col :md="10">
              <hr />
              <br />
              <h4 class="left margin-title">
                {{ $t("CONTROLES MITIGADORES") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  title="Controles Mitigadores"
                  width="200"
                  trigger="hover"
                  :content="
                    $t(`Los controles de mitigación son aquellos que
                    reducen los impactos derivados de un riesgo.`)
                  "
                >
                  <i slot="reference" class="el-icon-question" />
                </el-popover>
              </h4>
              <el-button
                v-if="
                  editable &&
                  risk.impactos.length > 0 &&
                  validarControlMitigador(risk.impactos)
                "
                icon="el-icon-d-arrow-right"
                class="right button-skip"
                type="primary"
                size="mini"
                @click="skipControlMitigador(risk.impactos)"
              >
                <b>{{ $t("No Aplica") }}</b>
              </el-button>
              <el-button
                v-if="
                  editable &&
                  risk.impactos.length > 0 &&
                  validarControlMitigador(risk.impactos)
                "
                icon="el-icon-plus"
                class="right"
                type="primary"
                size="mini"
                @click="openDialogControlMitigador()"
              >
                <b>{{ $t("Añadir Control Mitigador") }}</b>
              </el-button>
              <el-table
                row-class-name="rowClassTablaPloma"
                header-cell-class-name="header-cell-class-table-gray-2"
                :data="getControlesMitigadores(risk)"
                style="width: 100%"
              >
                <el-table-column prop="nombre" :label="$t('Nombre')" />
                <el-table-column
                  prop="id_impacto"
                  :label="$t('Impacto')"
                  width="90"
                />
                <el-table-column
                  v-if="editable"
                  align="center"
                  header-align="center"
                  width="125"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="
                        scope.row.not_apply === false ||
                        scope.row.hasOwnProperty('not_apply') === false
                      "
                      size="small"
                      @click="editDialogControlMitigador(scope.row)"
                      icon="el-icon-edit"
                    />
                    <el-button
                      type="danger"
                      size="small"
                      @click="deleteControlMitigador(scope.row)"
                      icon="el-icon-delete"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="!standard_risk_found && srrChecked"
      >
        <el-button @click="cleanDialogLogicData()">Cancelar</el-button>
        <el-button v-if="action === 'add'" type="primary" @click="onAcept"
          >Agregar riesgo</el-button
        >
        <el-button
          v-if="action === 'edit'"
          type="primary"
          @click="saveChange(risk), resetCambios()"
          >Modificar riesgo</el-button
        >
      </span>
      <span
        slot="footer"
        class="dialog-footer"
        v-else-if="standard_risk_found && srrChecked"
      >
        <el-button @click="rejectStandardRiskAdvice()"
          >Rechazar sugerencia</el-button
        >
        <el-button
          v-if="!noStandardRiskLeft"
          :disabled="!standardRiskButtonEnabled"
          type="primary"
          @click="addCustomRiskSRR"
          >Agregar como riesgo estandarizado</el-button
        >
        <el-button v-else type="primary">Cerrar formulario</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="Evaluador"
      width="40%"
      append-to-body
      :visible="dialogNewEvaluadorVisible"
    >
      <center v-if="searchUser">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <el-form
        v-else
        :model="formEvaluador"
        label-position="top"
        :rules="rulesEvaluador"
        ref="formEvaluador"
      >
        <el-form-item label="RUT" prop="rut" :label-width="formLabelWidth">
          <el-input
            v-model="formEvaluador.rut"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            title="RUT"
            width="200"
            trigger="hover"
            :content="$t('Escriba el RUT del evaluador')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item
          label="Nombre"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            :disabled="inputNombreDisable === true || !formEvaluador.rut"
            v-model="formEvaluador.nombre"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el Nombre del evaluador')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Cargo" prop="cargo" :label-width="formLabelWidth">
          <el-input
            :disabled="inputCargoDisable === true || !formEvaluador.rut"
            v-model="formEvaluador.cargo"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Cargo')"
            width="200"
            trigger="hover"
            :content="
              $t('Escriba el Cargo del evaluador al momento de la evaluación')
            "
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogEvaluador()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button
          type="primary"
          @click="editEvaluador('formEvaluador')"
          v-if="editingEvaluador"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button
          type="primary"
          @click="addEvaluador('formEvaluador')"
          v-else
          >{{ $t("Agregar") }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="Causa"
      :rules="rules"
      append-to-body
      ref="formCausa"
      :visible="dialogNewCausaVisible"
    >
      <p>
        {{
          $t(`A continuación se presenta un listado con causas predefenidas.
        En el caso que una causa del evento no se encuentre en listado,
        seleccionar la opción \'Otro\' al final del listado y agregarla en
        el recuadro de texto que se desplegara.`)
        }}
      </p>
      <el-select
        v-model="formCausa.nombreTemp"
        :placeholder="$t('Seleccione causa asociada')"
        class="with-help-box full-width"
      >
        <el-option-group
          v-for="group in causasInmediatasComputed"
          :key="group.label"
        >
          <p class="groupLabel">{{ group.label }}</p>
          <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-option-group>
      </el-select>
      <br />
      <br />
      <div v-if="formCausa.nombreTemp === 'other'">
        <el-input
          v-model="formCausa.nombre"
          class="with-help-box full-width"
          :placeholder="$t('Escriba causa del evento')"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogCausa()">{{ $t("Cancelar") }}</el-button>
        <el-button
          v-if="editingCausa"
          type="primary"
          @click="editCausa('formCausa')"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button v-else type="primary" @click="addCausa('formCausa')">{{
          $t("Agregar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Control Preventivo')"
      append-to-body
      :rules="rules"
      ref="formControlPreventivo"
      :visible="dialogNewControlPreventivoVisible"
    >
      <el-form :model="formControlPreventivo" label-position="top">
        <el-form-item
          :label="$t('Causas asociadas al control preventivo')"
          prop="causa"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlPreventivo.causas"
            multiple
            filterable
            class="with-help-box full-width"
            :placeholder="$t('Seleccione causas asociada')"
          >
            <el-option
              v-for="(causa, i) in risk.causas"
              :key="`CAUSA`+ (i + 1)"
              :label="`CA`+ (i + 1)"
              :value="causa.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('Nombre del control preventivo')"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlPreventivo.nombre"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item
          :label="
            $t(
              `${
                risk.tipo === 'medioambiente'
                  ? 'Jerarquía de Mitigación'
                  : 'Jerarquía de control'
              }`
            )
          "
          prop="jerarquia"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlPreventivo.jerarquiaControl"
            filterable
            class="with-help-box full-width"
            :placeholder="
              $t(
                `${
                  risk.tipo === 'medioambiente'
                    ? 'Seleccione Jerarquía de Mitigación'
                    : 'Seleccione Jerarquía de control'
                }`
              )
            "
          >
            <el-option
              v-for="jerarquia in risk.tipo === 'medioambiente'
                ? jerarquiaMedioambiente
                : jerarquiaSaludSeguridad"
              :key="jerarquia.value"
              :label="jerarquia.value"
              :value="jerarquia.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="risk.impactos.length > 0 && risk.impactos[0]['mfl'] > 3"
          :label="$t('¿Es control crítico?')"
          prop="critico"
          :label-width="formLabelWidth"
        >
          <el-switch
            class="with-help-box"
            v-model="formControlPreventivo.critico"
            active-text="Sí"
            inactive-text="No"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Control Crítico')"
            width="400"
            trigger="hover"
          >
            {{
              $t(`Son quellos controles que solo o en conjunto con otros
            controles reduce significativamente la probabilidad
            y/o el impacto de los Riesgos estandarizados.`)
            }}
            <br />
            {{
              $t(
                `Puede haber más de un control crítico para un riesgo material.`
              )
            }}
            <br />
            {{
              $t(
                `Elementos a considerar en la determinación de un control crítico:`
              )
            }}
            <ul>
              <li>
                {{
                  $t(`Única barrera/capa de protección disponible para la ocurrencia
                del evento o la exposición al impacto.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para prevenir o mitigar múltiples causas/impactos.`
                  )
                }}
              </li>
              <li>{{ $t(`Es independiente de otros controles.`) }}</li>
              <li>
                {{
                  $t(`El control es más alto en la jerarquía de controles que
                otros controles en consideración.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para detectar o prevenir que el evento escale.`
                  )
                }}
              </li>
            </ul>
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogControlPreventivo()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button
          type="primary"
          @click="editControlPreventivo('formControlPreventivo')"
          v-if="editingControlPreventivo"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button
          type="primary"
          @click="addControlPreventivo('formControlPreventivo')"
          v-else
          >{{ $t("Agregar") }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Impacto')"
      :rules="rules"
      append-to-body
      ref="formImpacto"
      :visible="dialogNewImpactoVisible"
    >
      <h4 v-if="risk.tipo === 'medioambiente'">
        {{ $t("DESCRIPCIÓN DEL IMPACTO") }}
      </h4>
      <el-row v-if="risk.tipo === 'medioambiente'">
        <el-col :sm="24">
          <el-input
            v-if="custom_name === true"
            type="textarea"
            :rows="3"
            placeholder="Ingrese descripción del impacto"
            v-model="formImpacto.descripcion"
          ></el-input>
          <el-select v-else v-model="formImpacto.descripcion" placeholder="Seleccione una opción" style="width: 100%; margin-right: 20px;">
            <el-option
              v-for="item in listado_impactos[risk.nombre]"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <br v-if="risk.tipo === 'medioambiente'" />
      <h4>{{ $t("SELECCIONE VALORES") }}</h4>
      <el-row>
        <el-col :sm="8">
          <el-button @click="dialogSeleccionSeveridadVisible = true">{{
            $t("Seleccione Nivel Severidad Residual")
          }}</el-button>
        </el-col>
        <el-col :sm="8">
          <el-button @click="dialogSeleccionProbabilidadVisible = true">{{
            $t("Seleccione Factor Probabilidad")
          }}</el-button>
        </el-col>
        <el-col :sm="8">
          <el-button @click="dialogSeleccionMFLVisible = true">{{
            $t("Seleccione Nivel Severidad MFL")
          }}</el-button>
        </el-col>
      </el-row>
      <br />
      <h4>{{ $t("INFORMACIÓN") }}</h4>
      <el-row>
        <el-col :sm="12">
          <label>{{ $t("Tipo Impacto") }}</label>
          <p class="info-txt" v-if="formImpacto.categoria">
            {{ formImpacto.categoria }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>{{ $t("Nivel Severidad Residual") }}</label>
          <p class="info-txt" v-if="formImpacto.nivel_severidad">
            {{ formImpacto.nivel_severidad }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>{{ $t("Nivel Severidad MFL") }}</label>
          <p class="info-txt" v-if="formImpacto.mfl">{{ formImpacto.mfl }}</p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col :sm="12">
          <label>{{ $t("Factor Severidad") }}</label>
          <p class="info-txt" v-if="formImpacto.factor_severidad">
            {{ formImpacto.factor_severidad }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>{{ $t("Factor Probabilidad") }}</label>
          <p class="info-txt" v-if="formImpacto.factor_probabilidad">
            {{ formImpacto.factor_probabilidad }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>RRR</label>
          <p
            class="info-txt"
            v-if="
              formImpacto.factor_severidad && formImpacto.factor_probabilidad
            "
          >
            {{
              (formImpacto.factor_severidad *
                10 *
                (formImpacto.factor_probabilidad * 10)) /
              (10 * 10)
            }}
          </p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col
          :sm="24"
          v-if="
            formImpacto.nivel_severidad === formImpacto.mfl &&
            formImpacto.nivel_severidad !== '' &&
            formImpacto.mfl !== ''
          "
        >
          <h4>{{ $t("COMENTARIO") }}</h4>
          <p class="info-txt">{{ formImpacto.comentario }}</p>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogImpacto()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button
          type="primary"
          @click="editImpacto('formImpacto')"
          v-if="editingImpacto"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button type="primary" @click="addImpacto('formImpacto')" v-else>{{
          $t("Agregar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Seleccione Nivel de Severidad')"
      append-to-body
      :visible="dialogSeleccionSeveridadVisible"
    >
      <p>
        {{
          $t(
            'Seleccione el "Nivel de Severidad Residual (NSR)" haciendo click sobre alguna de las descripciones que salen dentro de la Tabla. Esta selección resultará en obtener el "Nivel de Severidad" y el "Factor de Severidad". Tener en cuenta que el NSR debe ser menor al MFL (Máxima Pérdida Previsible).'
          )
        }}
      </p>
      <TablaSeveridad :click="seleccionaImpacto" :impactType="risk.tipo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionSeveridadVisible = false">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="42%"
      :before-close="handleClose"
      :title="$t('Seleccione Factor de Probabilidad')"
      append-to-body
      :visible="dialogSeleccionProbabilidadVisible"
    >
      <p>
        {{
          $t(
            'Seleccione el "Factor de Probabilidad" haciendo click sobre alguna de las descripciones que salen dentro de la tabla.'
          )
        }}
        <br />
        {{
          $t('Esta selección resultará en obtener el "Factor de Probabilidad".')
        }}
      </p>
      <TablaProbabilidad :click="seleccionaProbabilidad" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionProbabilidadVisible = false">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Seleccione MFL')"
      append-to-body
      :visible="dialogSeleccionMFLVisible"
    >
      <p>
        {{
          $t(
            'Seleccione el "Nivel de Severidad MFL (Máxima Pérdida Previsible)." haciendo click sobre alguna de las descripciones que salen dentro de la tabla. Esta selección resultará en obtener el "Nivel de Severidad MFL". Tener en cuenta que el MFL debe ser mayor a NSR.'
          )
        }}
      </p>
      <TablaSeveridad :click="seleccionaMFL" :impactType="risk.tipo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionMFLVisible = false">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Control Mitigador')"
      append-to-body
      :rules="rules"
      ref="formControlMitigador"
      :visible="dialogNewControlMitigadorVisible"
    >
      <el-form :model="formControlMitigador" label-position="top">
        <el-form-item
          :label="$t('Impacto')"
          prop="impacto"
          :label-width="formLabelWidth"
        >
          <el-select
            :disabled="true"
            v-model="formControlMitigador.impacto"
            filterable
            class="with-help-box full-width"
            :placeholder="$t('Seleccione impacto asociado')"
          >
            <el-option
              v-for="impacto in risk.impactos"
              :key="impacto.id"
              :label="impacto.categoria"
              :value="impacto.id"
            />
          </el-select>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Selección Impacto')"
            width="200"
            trigger="hover"
            :content="
              $t('Listado de impactos asociados al riesgo. Seleccione uno.')
            "
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item
          :label="$t('Nombre')"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlMitigador.nombre"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre')"
            width="200"
            trigger="hover"
            :content="
              $t(
                'Escriba el control mitigador. Debe ser breve, claro y preciso.'
              )
            "
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item
          :label="
            $t(
              `${
                risk.tipo === 'medioambiente'
                  ? 'Jerarquía de Mitigación'
                  : 'Jerarquía de control'
              }`
            )
          "
          prop="jerarquia"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlMitigador.jerarquiaControl"
            filterable
            class="with-help-box full-width"
            :placeholder="
              $t(
                `${
                  risk.tipo === 'medioambiente'
                    ? 'Seleccione Jerarquía de Mitigación'
                    : 'Seleccione Jerarquía de control'
                }`
              )
            "
          >
            <el-option
              v-for="jerarquia in risk.tipo === 'medioambiente'
                ? jerarquiaMedioambiente
                : jerarquiaSaludSeguridad"
              :key="jerarquia.value"
              :label="jerarquia.value"
              :value="jerarquia.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="risk.impactos.length > 0 && risk.impactos[0]['mfl'] > 3"
          :label="$t('¿Es control crítico?')"
          prop="critico"
          :label-width="formLabelWidth"
        >
          <el-switch
            class="with-help-box"
            v-model="formControlMitigador.critico"
            active-text="Sí"
            inactive-text="No"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Control Crítico')"
            width="400"
            trigger="hover"
          >
            {{
              $t(`Son quellos controles que solo o en conjunto con otros
            controles reduce significativamente la probabilidad
            y/o el impacto de los Riesgos estandarizados.`)
            }}
            <br />
            {{
              $t(
                `Puede haber más de un control crítico para un riesgo material.`
              )
            }}
            <br />
            {{
              $t(
                `Elementos a considerar en la determinación de un control crítico:`
              )
            }}
            <ul>
              <li>
                {{
                  $t(`Única barrera/capa de protección disponible para la ocurrencia
                del evento o la exposición al impacto.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para prevenir o mitigar múltiples causas/impactos.`
                  )
                }}
              </li>
              <li>{{ $t(`Es independiente de otros controles.`) }}</li>
              <li>
                {{
                  $t(`El control es más alto en la jerarquía de controles que
                otros controles en consideración.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para detectar o prevenir que el evento escale.`
                  )
                }}
              </li>
            </ul>
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogControlMitigador()">Cancelar</el-button>
        <el-button
          v-if="editingControlMitigador"
          type="primary"
          @click="editControlMitigador('formControlMitigador')"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button
          v-else
          type="primary"
          @click="addControlMitigador('formControlMitigador')"
          >{{ $t("Agregar") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { clone } from "lodash";
import uuid from "uuid/v4";
import Vue from "vue";
import axios from "axios";
import TablaSeveridad from "./TablaSeveridad.vue";
import TablaProbabilidad from "./TablaProbabilidad.vue";

export default {
  components: {
    TablaSeveridad,
    TablaProbabilidad,
    Circle9,
  },
  data() {
    return {
      showInfo: false,
      listado_impactos: {
        "Biodiversidad - Flora": [
          "Afectación a la Biodiversidad - flora",
          "Pérdida de Biodiversidad - flora"
        ],
        "Biodiversidad - Fauna": [
          "Afectación a la Biodiversidad - fauna",
          "Pérdida de Biodiversidad - fauna"
        ],
        "Generación residuos peligrosos" : [
            "Almacenamiento en lugares no autorizados",
            "Disposición final en lugares no autorizados.",
            "Derrame o disposición sobre suelo (sin contención)",
            "Incendio",
            "Emanación de gases",
            "Afectación sobre flora y fauna",
            "Mala segregación"
        ],
        "Generación residuos industriales": [
          "Afectación sobre flora y fauna",
          "Almacenamiento en lugares no autorizados",
          "Disposición final en lugares no autorizados.",
          "Derrame o disposición sobre suelo (sin contención)",
          "Incendio",
          "Mala segregación"
        ],
        "Generación residuos domésticos": [
          "Almacenamiento en lugares no autorizados",
          "Disposición final en lugares no autorizados.",
          "Derrame o disposición sobre suelo (sin contención)",
          "Incendio",
          "Emisión malos olores",
          "Atracción vectores sanitarios",
          "Mala segregación"
        ],
        "Generación ripios (residuos mineros masivos)": [
          "Almacenamiento en lugares no autorizados",
          "Disposición final en lugares no autorizados.",
          "Alteración calidad del suelo",
          "Afectación o perdida del patrimonio - Arqueología",
          "Afectación o perdida del patrimonio - Paleontología",
          "Alteración calidad de agua subterranea"
        ],
        "Generación relave (residuos mineros masivos)": [
          "Almacenamiento en lugares no autorizados",
          "Disposición final en lugares no autorizados.",
          "Afectación o perdida del patrimonio - Arqueología",
          "Afectación o perdida del patrimonio - Paleontología",
          "Afectación a la biodiversidad",
          "Perdida de biodiversidad ",
          "Derrame sobre suelo (sin contención)",
          "Alteración calidad de agua subterranea"
        ],
        "Generación estéril (residuos mineros masivos)": [
          "Almacenamiento en lugares no autorizados",
          "Afectación o perdida del patrimonio - Arqueología",
          "Afectación o perdida del patrimonio - Paleontología",
          "Afectación a la biodiversidad",
          "Perdida de biodiversidad ",
          "Disposición final en lugares no autorizados."
        ],
        "Manejo de sustancias peligrosas": [
          "Mala segregación ",
          "Emanación de gases",
          "Afectación a la biodiversidad",
          "Perdida de biodiversidad ",
          "Almacenamiento en lugares no autorizados",
          "Alteración calidad de aguas superficiales y/o marinas",
          "Incendio",
          "Derrame o disposición sobre suelo (sin contención)"
        ],
        "Manejo de concentrado": [
          "Alteración calidad de aguas superficiales y/o marinas",
          "Alteración calidad del aire",
          "Derrame sobre suelo (sin contención)",
          "Alteración calidad del suelo "
        ],
        "Manejo de aguas servidas": [
          "Derrame sobre suelo",
          "Alteración calidad de aguas superficiales y/o marinas",
          "Atracción vectores sanitarios",
          "Disposición final en lugares no autorizados.",
          "Emisión malos olores"
        ],
        "Descarga de salmuera": [
          "Alteración de calidad de aguas marinas",
          "Afectación actividad pesquera tradicional",
          "Afectación biodiversidad marina"
        ],
        "Extracción o uso de aguas continentales": [
          "Afectación a terceros",
          "Afectación a flora y fauna",
          "No cumplimiento de parametros de agua",
          "Alteración de la calidad del agua",
          "Perdida / disminución del recurso hídrico"
        ],
        "Manejo aguas de proceso": [
          "Alteración calidad de aguas superficiales y/o marinas",
          "Alteración de niveles del agua subterranea",
          "Alteración de la calidad del agua subterranea"
        ],
        "Emisión material particulado": [
          "Alteración de calidad de aire",
          "Exposición a material particulado ",
          "Afectación o perdida del patrimonio - Arqueología",
          "Afectación o perdida del patrimonio - Paleontología",
          "Superación límites maximos establecidos"
        ],
        "Emisión de GHG - COVs.": [
          "Alteración calidad de aire"
        ],
        "Generación de gases de combustión": [
          "Alteración calidad de aire",
          "Quejas de la Comunidad"
        ],
        "Emisión ruido": [
          "Superación límites máximos y afectación a terceros"
        ],
        "Interacción comunitaria": [
          "Alteración de desenvolvimiento comunitario",
          "Alteración de espacios significaión cultural",
          "Infracciones al codigo de conducta"
        ],
        "Uso de energía eléctrica": [
          "Afectación de la capa de ozono",
          "Generación de gases de efecto invernadero ",
          "Alteración del paisaje"
        ],
        "Patrimonio cultural": [
          "Afectación o perdida del patrimonio - Arqueología",
          "Afectación o perdida del patrimonio - Paleontología"
        ],
        "Emisión de luminosisdad": [
          "Contaminación lumínica"
        ],
        "Cambio climático": [
          "Falla de infraestructura por eventos extremos"
        ]
      },
      listado_nombres: [
      {
          value: '',
          label: 'Seleccione una opción'
        }, {
          value: 'Biodiversidad - Flora',
          label: 'Biodiversidad - Flora'
        }, {
          value: 'Biodiversidad - Fauna',
          label: 'Biodiversidad - Fauna'
        }, {
          value: 'Generación residuos peligrosos',
          label: 'Generación residuos peligrosos'
        }, {
          value: 'Generación residuos industriales',
          label: 'Generación residuos industriales'
        }, {
          value: 'Generación residuos domésticos',
          label: 'Generación residuos domésticos'
        }, {
          value: 'Generación ripios (residuos mineros masivos)',
          label: 'Generación ripios (residuos mineros masivos)'
        }, {
          value: 'Generación relave (residuos mineros masivos)',
          label: 'Generación relave (residuos mineros masivos)'
        }, {
          value: 'Generación estéril (residuos mineros masivos)',
          label: 'Generación estéril (residuos mineros masivos)'
        }, {
          value: 'Manejo de sustancias peligrosas',
          label: 'Manejo de sustancias peligrosas'
        }, {
          value: 'Manejo de concentrado',
          label: 'Manejo de concentrado'
        }, {
          value: 'Manejo de aguas servidas',
          label: 'Manejo de aguas servidas'
        }, {
          value: 'Descarga de salmuera',
          label: 'Descarga de salmuera'
        }, {
          value: 'Extracción o uso de aguas continentales',
          label: 'Extracción o uso de aguas continentales'
        }, {
          value: 'Manejo aguas de proceso',
          label: 'Manejo aguas de proceso'
        }, {
          value: 'Emisión material particulado',
          label: 'Emisión material particulado'
        }, {
          value: 'Emisión de GHG - COVs.',
          label: 'Emisión de GHG - COVs.'
        }, {
          value: 'Generación de gases de combustión',
          label: 'Generación de gases de combustión'
        }, {
          value: 'Emisión ruido',
          label: 'Emisión ruido'
        }, {
          value: 'Interacción comunitaria',
          label: 'Interacción comunitaria'
        }, {
          value: 'Uso de energía eléctrica',
          label: 'Uso de energía eléctrica'
        }, {
          value: 'Patrimonio cultural',
          label: 'Patrimonio cultural'
        }, {
          value: 'Emisión de luminosisdad',
          label: 'Emisión de luminosisdad'
        }, {
          value: 'Cambio climático',
          label: 'Cambio climático'
        }
      ],
      custom_name: false,
      local_cambios: [],
      count: 0,
      searchUser: false,
      inputCargoDisable: true,
      inputNombreDisable: true,
      componentKey: 0,
      dialogNewEvaluadorVisible: false,
      dialogNewCausaVisible: false,
      dialogNewImpactoVisible: false,
      dialogNewControlPreventivoVisible: false,
      dialogNewControlMitigadorVisible: false,
      dialogSeleccionSeveridadVisible: false,
      dialogSeleccionProbabilidadVisible: false,
      dialogSeleccionMFLVisible: false,
      standard_risks: [],
      standard_risks_original: [],
      standard_risk_message: "",
      standard_risk_found: false,
      standardRiskButtonEnabled: false,
      noStandardRiskLeft: false,
      srrLoading: false,
      srrChecked: false,
      waitingForStandardRisk: true,
      formCustomRisk: {
        nombre: null,
        tipo: null,
        standardRisk: null,
      },
      jerarquiaSaludSeguridad: [
        {
          value: "Eliminación",
        },
        {
          value: "Sustitución",
        },
        {
          value: "Controles de ingeniería",
        },
        {
          value: "Controles administrativos",
        },
        {
          value: "Elementos de Protección a las Personas (EPP)",
        },
      ],
      jerarquiaMedioambiente: [
        {
          value: "Evitar",
        },
        {
          value: "Minimizar",
        },
        {
          value: "Rehabilitar Impactos Medioambientales",
        },
      ],
      causasInmediatas: [
        {
          label: "Salud y Seguridad",
          options: [
            { value: "Acción de terceros" },
            { value: "Actuar sin autorización" },
            { value: "Actuar a velocidad anormal" },
            { value: "Conducta / comportamiento inadecuado" },
            { value: "Desviarse de los Métodos /normativas aceptadas" },
            { value: "Intervenir equipos energizados y/o en movimientos" },
            { value: "Mal manejo de materiales, equipos e insumos" },
            { value: "No advertir /señalizar" },
            { value: "No usar equipo de protección personal" },
            { value: "Omitir o neutralizar dispositivos de protección" },
            { value: "Presentarse en condiciones anormales" },
            { value: "Ubicarse en posición o postura incómoda" },
            { value: "Uso de vestuario o elementos extraños" },
            { value: "Uso inadecuado de datos /información" },
            { value: "Uso inadecuado de herramientas y equipos de protección" },
            { value: "Almacenamiento defectuoso" },
            { value: "Área/ Recinto congestionado o restringido" },
            { value: "Equipo de protección fuera de especificación" },
            {
              value:
                "Factores/ condiciones ambientales anormales (Exposiciones al ruido, radiación, falta ventilación / iluminación o temperaturas extremas)",
            },
            { value: "Falta o falla de protecciones / defensas" },
            {
              value:
                "Herramientas / materiales / equipos defectuoso o inapropiado",
            },
            { value: "Identificación y señalización incorrectas" },
            { value: "Método o Procedimiento Peligroso" },
            { value: "Orden y aseo deficientes" },
            { value: "Problemas en sistemas de energías" },
            { value: "Protección y defensas fuera de norma o especificación" },
            { value: "Sistemas de información deficiente" },
            {
              value:
                "Sobrecarga /saturación de sistemas /instalaciones / equipos",
            },
            { value: "Superficie de trabajo dañada / inadecuada" },
            { value: "Vehículo / equipo en mal estado" },
            { value: "Peligro de explosión o incendio" },
          ],
        },
        {
          label: "Medioambiente",
          options: [
            {
              value: "Ausencia de controles",
            },
            {
              value: "Falla de los controles",
            },
            {
              value: "No aplicación de los controles (fisicos)",
            },
            {
              value: "Falla de Materiales",
            },
            {
              value: "Accion de terceros",
            },
            {
              value: "No aplicación de procedimiento",
            },
            {
              value: "Almacenamiento defectuoso",
            },
            {
              value: "aplicación inadecuada de controles",
            },
            {
              value: "Desconocimiento de procedimiento",
            },
            {
              value: "Diseño inadecuado del control",
            },
            {
              value: "actividad no autorizada",
            },
            {
              value: "extraccion  sobre lo autorizado",
            },
            {
              value: "Falta de seguimiento al control ",
            },
            {
              value: "Daño por equipo móvil",
            },
          ],
        },
        {
          label: "Otro",
          options: [
            {
              label: "Otro",
              value: "other",
            },
          ],
        },
      ],
      editingCausa: false,
      editingCausaID: null,
      formCausa: {
        nombre: "",
        nombreTemp: "",
      },
      editingControlPreventivo: false,
      editingControlPreventivoID: null,
      formControlPreventivo: {
        nombre: "",
        critico: false,
        jerarquiaControl: "",
        causas: [],
      },
      editingImpacto: false,
      editingImpactoID: null,
      formImpacto: {
        categoria: "",
        descripcion: "",
        comentario: "",
        factor_severidad: "",
        factor_probabilidad: "",
        nivel_severidad: "",
        mfl: "",
      },
      editingControlMitigador: false,
      editingControlMitigadorID: null,
      formControlMitigador: {
        nombre: "",
        critico: false,
        jerarquiaControl: "",
        impacto: this.risk.impactos[0],
      },
      editingEvaluador: false,
      editingEvaluadorID: null,
      formEvaluador: {
        id: "",
        nombre: "",
        rut: "",
        cargo: "",
      },
      formLabelWidth: "150px",
      optionsCondicion: [
        { value: "Normal" },
        { value: "Anormal" },
        { value: "Emergencia" },
      ],
      rules: {
        nombre: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur",
          },
        ],
      },
      rulesEvaluador: {
        rut: [
          {
            required: true,
            message: "Por favor ingrese nombre de usuario",
            trigger: "change",
          },
        ],
        nombre: [
          {
            required: true,
            message: "Por favor ingrese Nombre",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    causasInmediatasComputed() {
      const selected = this.risk.causas.map((r) => r.nombre);
      const options = [];
      this.causasInmediatas.forEach((ci) => {
        const group = { label: ci.label, options: [] };
        ci.options.forEach((o) => {
          if (!selected.includes(o.value)) {
            group.options.push(o);
          } else {
          }
        });
        options.push(group);
      });
      return options;
    },
  },
  props: [
    "cambios",
    "editRisk",
    "saveChange",
    "action",
    "onAcept",
    "onClose",
    "visibleSync",
    "editable",
    "risk",
    "appendToBody",
    "allStandardRisks",
    "riskItem",
    "closeDialogCustomRisk",
  ],
  watch: {
    "formEvaluador.rut": function () {
      this.debounceInput();
    },
    "visibleSync": function () {
      if (this.visibleSync === true) {
        this.validMaName();
      }
    },
    "risk.nombre": function () {
      if (this.editRisk === false) {
        this.searchStandardRisk();
      } else {
        if (this.count > 0) {
          this.searchStandardRisk();
        } else {
          this.standard_risk_found = false;
          this.srrChecked = true;
        }
        this.count = 1;
      }
    },
  },
  methods: {
    resetDescripcion() {
      if (this.risk.tipo && this.risk.tipo.toLowerCase() === "medioambiente" && this.custom_name === false && this.risk.impactos.length > 0) {
        this.risk.impactos[0]["descripcion"] = "";
      }
    },
    validMaName() {
      if (this.risk.tipo && this.risk.tipo.toLowerCase() === "medioambiente" && this.visibleSync === true) {
        var self = this;
        var riesgos = this.listado_nombres.filter(function (el) {
          return el.value === self.risk.nombre;
        });
        if (riesgos && riesgos.length > 0) {
          this.custom_name = false;
        } else {
          this.custom_name = true;
        }
      }
    },
    resetName() {
      this.risk.nombre = "";
    },
    resetCambios() {
      this.local_cambios.forEach((lc) => {
        this.$store.dispatch("addChange", lc);
      });
      this.local_cambios = [];
    },
    rejectStandardRiskAdvice() {
      this.waitingForStandardRisk = false;
      this.standard_risk_found = false;
    },
    showStandardRisk() {
      const self = this;
      const filtering = this.$store.getters.role.faena_id;
      this.formCustomRisk.nombre = filtering;
      this.srrLoading = true;
      axios
        .get(
          `https://srr.inventarios.dev.bhp.lifeon.cl/standard_risk/${this.risk.nombre}/?job=${filtering}`
        )
        .then((response) => {
          self.srrChecked = true;
          const standardRiskBackUp = response.data.slice(0);
          const selectedRisks =
            self.$store.getters.inventario_copy.tareas[
              self.$store.getters.selectedIndexTask
            ].riesgos;
          if (selectedRisks !== undefined) {
            for (let i = 0; i < selectedRisks.length; i++) {
              for (let j = 0; j < response.data.length; j++) {
                if (response.data[j].id === selectedRisks[i]._id) {
                  response.data.splice(j, 1);
                  break;
                }
              }
            }
          }
          self.standard_risks = response.data;
          self.standard_risk_found = true;

          if (self.standard_risks.length > 0) {
            self.standard_risk_message =
              "El riesgo que está ingresando puede estar asociado a los siguientes Riesgos estandarizados. " +
              "Para continuar debe seleccionar alguno de los siguientes Riesgos estandarizados para agregarlos como tal";
          } else if (standardRiskBackUp.length !== response.data.length) {
            self.standard_risk_message =
              "El riesgo que está ingresando puede estar asociado a alguno de los siguientes " +
              "Riesgos estandarizados que ya tiene agregado:";
            self.standard_risks_original = standardRiskBackUp;
            self.noStandardRiskLeft = true;
          } else {
            self.rejectStandardRiskAdvice();
          }
          self.srrLoading = false;
        })
        .catch((error) => {
          console.log("No se encontró ninguna similitud con algún estandarizado");
          self.srrLoading = false;
          self.srrChecked = true;
          self.rejectStandardRiskAdvice();
        });
      return null;
    },
    addCustomRiskSRR() {
      for (let i = 0; i < this.allStandardRisks.length; i++) {
        if (this.formCustomRisk.standardRisk === this.allStandardRisks[i]._id) {
          this.$store.dispatch("addRisk", this.allStandardRisks[i]);
          this.$notify.info({
            duration: 3000,
            title: "Atención",
            message: "Riesgos estandarizados se agregaron exitosamente",
          });
          this.cleanDialogLogicData();
          this.saveChange();
        }
      }
      if (this.closeDialogCustomRisk) this.closeDialogCustomRisk();
      this.srrLoading = false;
    },
    enableStandardRiskButton() {
      this.standardRiskButtonEnabled = true;
    },
    resetSrrBooleans() {
      this.noStandardRiskLeft = true;
      this.standard_risk_found = false;
      this.noStandardRiskLeft = false;
      this.srrLoading = false;
      this.srrChecked = false;
      this.waitingForStandardRisk = true;
    },
    cleanDialogLogicData() {
      this.count = 0;
      this.onClose();
      this.resetSrrBooleans();
      this.srrLoading = false;
    },
    searchStandardRisk: _.debounce(function () {
      this.showStandardRisk();
    }, 1000),
    debounceInput: _.debounce(function () {
      this.searchUser = true;
      const userExist = this.$store.getters.usersFaena.find(
        (x) => x.rut === this.formEvaluador.rut
      );
      if (userExist) {
        this.formEvaluador = {
          id: userExist._id,
          nombre: `${userExist.nombre} ${userExist.apellido}`,
          rut: userExist.rut,
        };
        this.inputNombreDisable = true;
        this.inputCargoDisable = false;
        this.searchUser = false;
      } else {
        axios
          .get(`/usuarios/by_rut/${this.formEvaluador.rut}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            if (response.data.success !== false) {
              this.formEvaluador.id = response.data._id;
              this.formEvaluador.nombre = `${response.data.nombre} ${response.data.apellido}`;
              this.formEvaluador.rut = response.data.rut;
              this.inputNombreDisable = true;
              this.inputCargoDisable = false;
              this.searchUser = false;
            } else {
              this.inputNombreDisable = false;
              this.inputCargoDisable = false;
              this.formEvaluador.id = "";
              /* this.formEvaluador.nombre = '';
            this.formEvaluador.cargo = ''; */
              this.searchUser = false;
            }
          });
      }
    }, 1500),
    validarControlMitigador(impacto) {
      let visible = false;
      impacto.forEach((imp) => {
        if (imp.controles_mitigadores && imp.controles_mitigadores.length > 0) {
          imp.controles_mitigadores.forEach((mitigador) => {
            if (mitigador.not_apply === true) {
              visible = false;
            } else {
              visible = true;
            }
          });
        } else {
          visible = true;
        }
      });
      return visible;
    },
    setTypeRisk(typeRisk) {
      if (this.risk.tipo === null || this.risk.impactos.length === 0) {
        this.changeType(typeRisk);
      } else {
        this.$confirm(
          "Al cambiar el tipo de impacto se reestablecerá la evaluación del impacto y los riesgos mitigadores ya definidos. ¿Seguro deseas continuar?",
          "Advertencia",
          {
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        )
          .then(() => {
            this.changeType(typeRisk);
            this.risk.impactos = [];
            // this.risk.causas = [];
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Acción cancelada",
            });
          });
      }
    },
    changeType(typeRisk) {
      this.local_cambios.push({
        num: this.$store.getters.cambios.length + 1,
        id: this.$store.getters.cambios.length + 1,
        tarea:
          this.$store.getters.inventario_copy.tareas[
            this.$store.getters.selectedIndexTask
          ]["nombre"],
        riesgo: this.risk.nombre,
        descripcion: `Se cambia tipo de riesgo a ${typeRisk}`,
        date: new Date(),
      });
      this.risk.tipo = typeRisk;
      this.risk.salud = typeRisk === "salud";
      this.risk.seguridad = typeRisk === "seguridad";
      if (typeRisk === "medioambiente") {
        this.risk.nombre = "";
        this.risk.medioambiental = true;
        this.risk.medioambiente = {};
      } else {
        this.risk.medioambiental = false;
        this.risk.medioambiente = {};
      }
    },
    handleClose() {
      this.dialogNewEvaluadorVisible = false;
      this.dialogNewCausaVisible = false;
      this.dialogNewImpactoVisible = false;
      this.dialogNewControlPreventivoVisible = false;
      this.dialogNewControlMitigadorVisible = false;
      this.dialogSeleccionSeveridadVisible = false;
      this.dialogSeleccionProbabilidadVisible = false;
      this.dialogSeleccionMFLVisible = false;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
                controlesIndicator[control.nombre].jerarquiaControl =
                  control.jerarquiaControl;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map((key) => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
        jerarquiaControl: controlesIndicator[key].jerarquiaControl,
      }));
      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getFactores(risk) {
      let mfl = 0;
      let rrr = 0;
      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
          }
        });
      }
      return [
        {
          mfl,
          rrr,
        },
      ];
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    tablaControlCritico(row, index) {
      if (row.critico) {
        return "control-critico";
      }
    },
    addCausa(formName) {
      let causa = this.formCausa.nombre;
      if (this.formCausa.nombreTemp !== "other") {
        causa = this.formCausa.nombreTemp;
      }
      if (!causa) {
        this.$message({
          message: this.$t("Debes seleccionar o escribir una causa"),
          type: "error",
        });
        return;
      }

      this.risk.causas.push({ id: uuid(), nombre: causa });

      this.local_cambios.push({
        num: this.$store.getters.cambios.length + 1,
        id: this.$store.getters.cambios.length + 1,
        tarea:
          this.$store.getters.inventario_copy.tareas[
            this.$store.getters.selectedIndexTask
          ]["nombre"],
        riesgo: this.risk.nombre,
        descripcion: `Se agrega la causa ${causa}`,
        date: new Date(),
      });

      this.closeDialogCausa();
    },
    closeDialogCausa() {
      this.editingCausa = false;
      this.editingCausaID = null;
      this.formCausa.nombre = "";
      this.formCausa.nombreTemp = "";
      this.dialogNewCausaVisible = false;
    },
    addImpacto(formName) {
      if (
        this.formImpacto.factor_severidad &&
        this.formImpacto.factor_probabilidad &&
        this.formImpacto.mfl
      ) {
        const impacto = {
          id: uuid(),
          descripcion: this.formImpacto.descripcion,
          comentario: this.formImpacto.comentario,
          categoria: this.formImpacto.categoria,
          factor_severidad: this.formImpacto.factor_severidad,
          nivel_severidad: this.formImpacto.nivel_severidad,
          factor_probabilidad: this.formImpacto.factor_probabilidad,
          mfl: this.formImpacto.mfl,
          controles_mitigadores: [],
        };
        this.risk.impactos.push(impacto);
        this.local_cambios.push({
          num: this.$store.getters.cambios.length + 1,
          id: this.$store.getters.cambios.length + 1,
          tarea:
            this.$store.getters.inventario_copy.tareas[
              this.$store.getters.selectedIndexTask
            ]["nombre"],
          riesgo: this.risk.nombre,
          descripcion: `Se agrega nuevo impacto / nuevos valores -> (MFL: ${impacto.mfl}, Factor Probabilidad: ${impacto.factor_probabilidad}, 
          Factor Severidad: ${impacto.factor_severidad}, Nivel Severidad: ${impacto.nivel_severidad}, Categoría: ${impacto.categoria})`,
          date: new Date(),
        });
      }
      this.closeDialogImpacto();
    },
    closeDialogImpacto() {
      this.editingImpacto = false;
      this.editingImpactoID = null;
      this.formImpacto.factor_severidad = "";
      this.formImpacto.nivel_severidad = "";
      this.formImpacto.factor_probabilidad = "";
      this.formImpacto.categoria = "";
      this.formImpacto.descripcion = "";
      this.formImpacto.mfl = "";
      this.formImpacto.comentario = "";
      this.dialogNewImpactoVisible = false;
    },
    seleccionaImpacto(impacto) {
      this.formImpacto.mfl = "";
      this.formImpacto.factor_severidad = "";
      this.formImpacto.factor_probabilidad = "";
      this.formImpacto.comentario = "";
      if (this.formImpacto.mfl) {
        if (impacto.nivelSeveridad > this.formImpacto.mfl) {
          this.$alert(
            `${this.$t(
              "Tu Nivel de Severidad Residual debe ser menor o igual al MFL"
            )} (${this.formImpacto.mfl})`,
            this.$t("Atención"),
            { type: "error" }
          );
          return;
        }
        if (impacto.nivelSeveridad !== this.formImpacto.mfl) {
          this.formImpacto.comentario = "";
        }
        if (impacto.nivelSeveridad === this.formImpacto.mfl) {
          this.$prompt(
            "Su nivel de severidad residual es igual al nivel de severidad MFL, debido a esto debe ingresar un comentario explicando las razones.",
            "Ingrese comentario",
            {
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              inputType: "textarea",
              inputErrorMessage: "Comentario invalido",
            }
          ).then(({ value }) => {
            this.$message({
              type: "success",
              message: "Comentario ingresado con exito",
            });
            this.formImpacto.comentario = value;
            this.formImpacto.nivel_severidad = impacto.nivelSeveridad;
            this.formImpacto.factor_severidad = impacto.factorSeveridad;
            // Setear severidad por tipo de impacto
            if (this.risk.tipo === "salud") {
              this.formImpacto.categoria = "Salud";
            } else if (this.risk.tipo === "seguridad") {
              this.formImpacto.categoria = "Seguridad";
            } else if (
              this.risk.tipo === "medioambiental" ||
              this.risk.tipo === "medioambiente"
            ) {
              this.formImpacto.categoria = "Medioambiente";
            }
            this.dialogSeleccionSeveridadVisible = false;
          });
          return;
        }
      }
      this.formImpacto.nivel_severidad = impacto.nivelSeveridad;
      this.formImpacto.factor_severidad = impacto.factorSeveridad;
      // Setear severidad por tipo de impacto
      if (this.risk.tipo === "salud") {
        this.formImpacto.categoria = "Salud";
      } else if (this.risk.tipo === "seguridad") {
        this.formImpacto.categoria = "Seguridad";
      } else if (
        this.risk.tipo === "medioambiental" ||
        this.risk.tipo === "medioambiente"
      ) {
        this.formImpacto.categoria = "Medioambiente";
      }
      this.dialogSeleccionSeveridadVisible = false;
    },
    seleccionaMFL(impacto, tipo) {
      if (this.formImpacto.nivel_severidad) {
        if (impacto.nivelSeveridad < this.formImpacto.nivel_severidad) {
          this.$alert(
            `${this.$t(
              "Tu MFL debe ser mayor o igual al Nivel de Severidad Residual"
            )} (${this.formImpacto.nivel_severidad})`,
            this.$t("Atención"),
            { type: "error" }
          );
          return;
        }
        if (impacto.nivelSeveridad === this.formImpacto.nivel_severidad) {
          this.$prompt(
            "Atención MFL y Nivel de severidad son iguales, debido a esto debe ingresar un comentario explicando las razones.",
            "Ingrese comentario",
            {
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              inputType: "textarea",
              inputErrorMessage: "Comentario invalido",
            }
          ).then(({ value }) => {
            this.$message({
              type: "success",
              message: "Comentario ingresado con exito",
            });
            this.formImpacto.comentario = value;
            this.formImpacto.mfl = impacto.nivelSeveridad;
            this.dialogSeleccionMFLVisible = false;
          });
          return;
        }
      }
      this.formImpacto.comentario = "";
      this.formImpacto.mfl = impacto.nivelSeveridad;
      this.dialogSeleccionMFLVisible = false;
    },
    seleccionaProbabilidad(probabilidad) {
      this.formImpacto.factor_probabilidad = probabilidad;
      this.dialogSeleccionProbabilidadVisible = false;
    },
    addControlPreventivo(formName) {
      const control = clone(this.formControlPreventivo);
      if (control.nombre && control.causas.length > 0) {
        const controlPreventivo = {
          id: uuid(),
          nombre: control.nombre,
          critico: control.critico,
          jerarquiaControl: control.jerarquiaControl,
        };
        control.causas.forEach((causeId) => {
          const causeIndex = this.risk.causas.findIndex(
            (cause) => cause.id === causeId
          );
          if (causeIndex !== -1) {
            if (!this.risk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.risk.causas, causeIndex, {
                ...this.risk.causas[causeIndex],
                controles_preventivos: [],
              });
            }
            this.risk.causas[causeIndex].controles_preventivos.push(
              controlPreventivo
            );
            this.local_cambios.push({
              num: this.$store.getters.cambios.length + 1,
              id: this.$store.getters.cambios.length + 1,
              tarea:
                this.$store.getters.inventario_copy.tareas[
                  this.$store.getters.selectedIndexTask
                ]["nombre"],
              riesgo: this.risk.nombre,
              descripcion: `Se agrega control preventivo (Nombre: ${
                control.nombre
              }, Crítico: ${
                control.critico === true ? "Si" : "No"
              }, Jerarquía de Control: ${control.jerarquiaControl})`,
              date: new Date(),
            });
          }
        });
        this.closeDialogControlPreventivo();
      } else {
        this.$alert(`Para continuar debe completar todos los campos solicitados`, 'Información', {
          confirmButtonText: 'Aceptar',
        });
      }
    },
    closeDialogControlPreventivo() {
      this.editingControlPreventivo = false;
      this.editingControlPreventivoID = null;
      this.formControlPreventivo.nombre = "";
      this.formControlPreventivo.critico = false;
      this.formControlPreventivo.causas = [];
      this.formControlPreventivo.jerarquiaControl = "";
      this.dialogNewControlPreventivoVisible = false;
    },
    addControlMitigador(formName) {
      const control = clone(this.formControlMitigador);
      if (control.nombre && control.impacto) {
        const control = clone(this.formControlMitigador);
        if (!this.risk.impactos[0].controles_mitigadores) {
          Vue.set(this.risk.impactos, 0, {
            ...this.risk.impactos[0],
            controles_mitigadores: [],
          });
        }
        const controlMitigador = {
          id: uuid(),
          nombre: control.nombre,
          critico: control.critico,
          jerarquiaControl: control.jerarquiaControl,
          not_apply: false,
        };
        this.risk.impactos[0].controles_mitigadores.push(controlMitigador);
        this.local_cambios.push({
          num: this.$store.getters.cambios.length + 1,
          id: this.$store.getters.cambios.length + 1,
          tarea:
            this.$store.getters.inventario_copy.tareas[
              this.$store.getters.selectedIndexTask
            ]["nombre"],
          riesgo: this.risk.nombre,
          descripcion: `Se agrega control mitigador (Nombre: ${
            control.nombre
          }, Crítico: ${
            control.critico === true ? "Si" : "No"
          }, Jerarquía de Control: ${control.jerarquiaControl}))`,
          date: new Date(),
        });
      }
      this.closeDialogControlMitigador();
    },
    skipControlMitigador(impacto) {
      impacto.forEach((imp) => {
        if (imp.controles_mitigadores && imp.controles_mitigadores.length > 0) {
          this.$confirm(
            this.$t(
              "Esto borrará todos los controles mitigadores registrados. ¿Está seguro que desea continuar?"
            ),
            this.$t("Atención"),
            {
              type: "warning",
            }
          ).then(() => {
            this.risk.impactos[0].controles_mitigadores = [];
            this.addSkipControlMitigador();
          });
        } else {
          this.addSkipControlMitigador();
        }
      });
    },
    addSkipControlMitigador() {
      this.formControlMitigador = {
        nombre: "No Aplica",
        critico: false,
        impacto: this.risk.impactos[0].id,
      };
      const impactIndex = this.risk.impactos.findIndex(
        (impact) => impact.id === this.formControlMitigador.impacto
      );
      if (impactIndex !== -1) {
        if (!this.risk.impactos[impactIndex].controles_mitigadores) {
          Vue.set(this.risk.impactos, impactIndex, {
            ...this.risk.impactos[impactIndex],
            controles_mitigadores: [],
          });
        }
        const controlMitigador = {
          id: uuid(),
          nombre: this.formControlMitigador.nombre,
          critico: this.formControlMitigador.critico,
          jerarquiaControl: this.formControlMitigador.jerarquiaControl,
          not_apply: true,
        };
        this.risk.impactos[impactIndex].controles_mitigadores.push(
          controlMitigador
        );
      }
      this.closeDialogControlMitigador();
    },
    closeDialogControlMitigador() {
      this.editingControlMitigador = false;
      this.editingControlMitigadorID = null;
      this.formControlMitigador.nombre = "";
      this.formControlMitigador.critico = false;
      this.formControlMitigador.impacto = this.risk.impactos[0];
      this.formControlMitigador.jerarquiaControl = "";
      this.dialogNewControlMitigadorVisible = false;
    },
    openDialogControlMitigador() {
      this.formControlMitigador.impacto = this.risk.impactos[0];
      this.dialogNewControlMitigadorVisible = true;
    },
    deleteCausa(cause) {
      this.$confirm(
        this.$t(
          "Esto borrará la causa y todos sus controles asociados. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.risk.causas.forEach((causa, causeIndex) => {
          if (causa.id === cause.id) {
            this.risk.causas.splice(causeIndex, 1);
            this.componentKey = this.componentKey + 1;
            this.local_cambios.push({
              num: this.$store.getters.cambios.length + 1,
              id: this.$store.getters.cambios.length + 1,
              tarea:
                this.$store.getters.inventario_copy.tareas[
                  this.$store.getters.selectedIndexTask
                ]["nombre"],
              riesgo: this.risk.nombre,
              descripcion: `Se elimina la causa ${cause.nombre}`,
              date: new Date(),
            });
          }
        });
      });
    },
    deleteImpacto(impact) {
      this.$confirm(
        this.$t(
          "Esto borrará el impacto y todos sus controles asociados. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        const impactIndex = this.risk.impactos.findIndex(
          (impact) => impact.id === impact.id
        );
        if (impactIndex >= 0) {
          Vue.delete(this.risk.impactos, impactIndex);
          this.local_cambios.push({
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea:
              this.$store.getters.inventario_copy.tareas[
                this.$store.getters.selectedIndexTask
              ]["nombre"],
            riesgo: this.risk.nombre,
            descripcion: `Se elimina el impacto con categoría ${impact.categoria}.`,
            date: new Date(),
          });
        }
      });
    },
    deleteControlPreventivo(control) {
      this.$confirm(
        this.$t(
          "Esto borrará el control preventivo. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.risk.causas.forEach((cause, causeIndex) => {
          cause.controles_preventivos.forEach((cp, cp_index) => {
            if (cp.id === control.id) {
              cause.controles_preventivos.splice(cp_index, 1);
              if (
                this.$route.path !== "/admin/riesgos-estandarizados" &&
                this.$route.path !== "/es/inventario/tareas/paso1"
              ) {
                this.local_cambios.push({
                  num: this.$store.getters.cambios.length + 1,
                  id: this.$store.getters.cambios.length + 1,
                  tarea:
                    this.$store.getters.inventario_copy.tareas[
                      this.$store.getters.selectedIndexTask
                    ]["nombre"],
                  riesgo: this.risk.nombre,
                  descripcion: `Se elimina el control preventivo ${control.nombre}`,
                  date: new Date(),
                });
              }
            }
          });
        });
      });
    },
    deleteControlMitigador(control) {
      this.$confirm(
        this.$t(
          "Esto borrará el control mitigador. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        const impactIndex = this.risk.impactos.findIndex(
          (impact) => impact.id === control.impactoId
        );
        if (impactIndex >= 0) {
          const impact = this.risk.impactos[impactIndex];
          const controlIndex = impact.controles_mitigadores.findIndex(
            (control) => control.id === control.id
          );
          if (controlIndex >= 0) {
            Vue.delete(
              this.risk.impactos[impactIndex].controles_mitigadores,
              controlIndex
            );
          }
        }
        this.local_cambios.push({
          num: this.$store.getters.cambios.length + 1,
          id: this.$store.getters.cambios.length + 1,
          tarea:
            this.$store.getters.inventario_copy.tareas[
              this.$store.getters.selectedIndexTask
            ]["nombre"],
          riesgo: this.risk.nombre,
          descripcion: `Se elimina el control mitigador ${control.nombre}`,
          date: new Date(),
        });
      });
    },
    editDialogCausa(causa) {
      this.formCausa = {
        nombre: "",
        nombreTemp: "",
      };
      let isOnList = false;
      for (const index in this.causasInmediatas) {
        for (let i = 0; i < this.causasInmediatas[index].options.length; i++) {
          const causaPredefinida =
            this.causasInmediatas[index].options[i].value;
          if (causaPredefinida === causa.nombre) {
            isOnList = true;
          }
        }
      }
      if (!isOnList) {
        this.formCausa.nombreTemp = "other";
        this.formCausa.nombre = causa.nombre;
      } else {
        this.formCausa.nombreTemp = causa.nombre;
      }
      this.editingCausa = true;
      this.editingCausaID = causa.id;
      this.dialogNewCausaVisible = true;
    },
    editCausa(formCausa) {
      let causa = this.formCausa.nombre;
      if (this.formCausa.nombreTemp !== "other") {
        causa = this.formCausa.nombreTemp;
      }
      if (!causa) {
        this.$message({
          message: this.$t("Debes seleccionar o escribir una causa"),
          type: "error",
        });
        return;
      }
      const index = this.risk.causas.findIndex(
        (causa) => causa.id === this.editingCausaID
      );
      if (index !== -1) {
        this.local_cambios.push({
          num: this.$store.getters.cambios.length + 1,
          id: this.$store.getters.cambios.length + 1,
          tarea:
            this.$store.getters.inventario_copy.tareas[
              this.$store.getters.selectedIndexTask
            ]["nombre"],
          riesgo: this.risk.nombre,
          descripcion: `Se actualiza causa ${this.risk.causas[index].nombre} / Nuevo valor --> ${causa}`,
          date: new Date(),
        });
        this.risk.causas[index].nombre = causa;
        this.forceRerender();
      }
      this.closeDialogCausa();
    },
    editDialogImpacto(impacto) {
      this.formImpacto = {
        categoria: impacto.categoria,
        descripcion: impacto.descripcion || "",
        comentario: impacto.comentario,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl,
      };
      this.editingImpacto = true;
      this.editingImpactoID = impacto.id;
      this.dialogNewImpactoVisible = true;
    },
    editImpacto(formImpacto) {
      if (
        this.formImpacto.factor_severidad &&
        this.formImpacto.factor_probabilidad &&
        this.formImpacto.mfl
      ) {
        // this.editImpact(this.formImpacto, this.editingImpactoID);

        const impactIndex = this.risk.impactos.findIndex(
          (impact) => impact.id === this.editingImpactoID
        );
        if (impactIndex >= 0) {
          Vue.set(this.risk.impactos, impactIndex, {
            ...this.risk.impactos[impactIndex],
            categoria: this.formImpacto.categoria,
            descripcion: this.formImpacto.descripcion,
            comentario: this.formImpacto.comentario,
            factor_severidad: this.formImpacto.factor_severidad,
            factor_probabilidad: this.formImpacto.factor_probabilidad,
            nivel_severidad: this.formImpacto.nivel_severidad,
            mfl: this.formImpacto.mfl,
          });
          this.local_cambios.push({
            num: this.$store.getters.cambios.length + 1,
            id: this.$store.getters.cambios.length + 1,
            tarea:
              this.$store.getters.inventario_copy.tareas[
                this.$store.getters.selectedIndexTask
              ]["nombre"],
            riesgo: this.risk.nombre,
            descripcion: `Se actualiza el impacto ${this.formImpacto.categoria} 
            / nuevos valores -> (MFL: ${this.formImpacto.mfl}, 
            Factor Probabilidad: ${this.formImpacto.factor_probabilidad}, 
            Factor Severidad: ${this.formImpacto.factor_severidad}, 
            Nivel Severidad: ${this.formImpacto.nivel_severidad}, 
            Categoría: ${this.formImpacto.categoria})`,
            date: new Date(),
          });
        }
        this.closeDialogImpacto();
      } else {
        this.$alert(
          "Para continuar debe seleccionar el factor de severidad, factor de probabilidad y el MFL.",
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
          }
        );
      }
    },
    editDialogControlPreventivo(control) {
      this.formControlPreventivo = {
        nombre: control.nombre,
        critico: control.critico,
        causas: control.causasID,
        jerarquiaControl: control.jerarquiaControl,
      };
      this.editingControlPreventivo = true;
      this.editingControlPreventivoID = control.id;
      this.dialogNewControlPreventivoVisible = true;
    },
    editControlPreventivo(formControl) {
      const control = clone(this.formControlPreventivo);
      //
      const { risk } = this;
      risk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            (control) => control.id === this.editingControlPreventivoID
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            const oldValue = JSON.parse(
              JSON.stringify(cause.controles_preventivos[controlIndex])
            );
            Vue.set(cause.controles_preventivos, controlIndex, {
              ...cause.controles_preventivos[controlIndex],
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
            });
            if (
              this.$route.path !== "/admin/riesgos-estandarizados" &&
              this.$route.path !== "/es/inventario/tareas/paso1"
            ) {
              this.local_cambios.push({
                num: this.$store.getters.cambios.length + 1,
                id: this.$store.getters.cambios.length + 1,
                tarea:
                  this.$store.getters.inventario_copy.tareas[
                    this.$store.getters.selectedIndexTask
                  ]["nombre"],
                riesgo: this.risk.nombre,
                descripcion: `Se actualiza el control preventivo ${
                  oldValue.nombre
                } / Nuevos valores --> ( Nombre: ${control.nombre}, Crítico: ${
                  control.critico === true ? "Si" : "No"
                }, Jerarquía de control: ${control.jerarquiaControl})`,
                date: new Date(),
              });
            }
          } else {
            // Agregar control a causa

            /* CORREGIR */
            if (!cause.controles_preventivos) {
              cause["controles_preventivos"] = [];
            }
            const controlPreventivo = {
              id: this.editingControlPreventivoID,
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
            };
            cause.controles_preventivos.push(controlPreventivo);
            if (
              this.$route.path !== "/admin/riesgos-estandarizados" &&
              this.$route.path !== "/es/inventario/tareas/paso1"
            ) {
              this.local_cambios.push({
                num: this.$store.getters.cambios.length + 1,
                id: this.$store.getters.cambios.length + 1,
                tarea:
                  this.$store.getters.inventario_copy.tareas[
                    this.$store.getters.selectedIndexTask
                  ]["nombre"],
                riesgo: this.risk.nombre,
                descripcion: `Se agregó el control preventivo ${control.nombre} a la causa ${this.risk.causas[causeIndex].nombre}.`,
                date: new Date(),
              });
            }
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            Vue.delete(cause.controles_preventivos, controlIndex);
          }
        }
      });
      this.forceRerender();
      this.closeDialogControlPreventivo();
    },
    editDialogControlMitigador(control) {
      this.formControlMitigador = {
        nombre: control.nombre,
        critico: control.critico,
        impacto: control.impactoId,
        jerarquiaControl: control.jerarquiaControl,
      };
      this.editingControlMitigador = true;
      this.editingControlMitigadorID = control.id;
      this.dialogNewControlMitigadorVisible = true;
    },
    editControlMitigador(formControl) {
      const control = clone(this.formControlMitigador);
      if (control.nombre && control.impacto) {
        this.risk.impactos.forEach((impact, impactIndex) => {
          // Se busca si este impacto ya tiene este control asignado
          let controlIndex = -1;
          if (impact.controles_mitigadores) {
            controlIndex = impact.controles_mitigadores.findIndex(
              (control) => control.id === this.editingControlMitigadorID
            );
          }

          // El control editado, tiene asociada este impacto?
          if (control.impacto === impact.id) {
            // Este control ya existe en el impacto?
            if (controlIndex >= 0) {
              Vue.set(
                this.risk.impactos[impactIndex].controles_mitigadores,
                controlIndex,
                {
                  ...this.risk.impactos[impactIndex].controles_mitigadores[
                    controlIndex
                  ],
                  nombre: control.nombre,
                  critico: control.critico,
                  jerarquiaControl: control.jerarquiaControl,
                }
              );
              this.local_cambios.push({
                num: this.$store.getters.cambios.length + 1,
                id: this.$store.getters.cambios.length + 1,
                tarea:
                  this.$store.getters.inventario_copy.tareas[
                    this.$store.getters.selectedIndexTask
                  ]["nombre"],
                riesgo: this.risk.nombre,
                descripcion: `Se actualiza el control mitigador ${
                  control.nombre
                } / Nuevos valores --> ( Nombre: ${control.nombre}, Crítico: ${
                  control.critico === true ? "Si" : "No"
                }, Jerarquía de control: ${control.jerarquiaControl})`,
                date: new Date(),
              });
            } else {
              // Agregar control a impacto
              if (!impact.controles_mitigadores) {
                impact.controles_mitigadores = [];
              }
              const controlMitigador = {
                id: this.editingControlMitigadorID,
                nombre: control.nombre,
                critico: control.critico,
                jerarquiaControl: control.jerarquiaControl,
              };
              this.risk.impactos[impactIndex].controles_mitigadores.push(
                controlMitigador
              );
              this.local_cambios.push({
                num: this.$store.getters.cambios.length + 1,
                id: this.$store.getters.cambios.length + 1,
                tarea:
                  this.$store.getters.inventario_copy.tareas[
                    this.$store.getters.selectedIndexTask
                  ]["nombre"],
                riesgo: this.risk.nombre,
                descripcion: `Se agregó el control mitigador ${control.nombre} al impacto con categoría ${impact.categoria}.`,
                date: new Date(),
              });
            }
            // El control editado no tiene este impacto asociada actualmente
          } else {
            // Este control ya existe en el impacto?
            if (controlIndex >= 0) {
              // Entonces se borra
              Vue.delete(
                this.risk.impactos[impactIndex].controles_mitigadores,
                controlIndex
              );
            }
          }
        });
      }
      this.closeDialogControlMitigador();
    },
    closeDialogEvaluador() {
      this.editingEvaluador = false;
      this.formEvaluador = {
        nombre: null,
        cargo: null,
        rut: null,
        empresa: null,
      };
      this.dialogNewEvaluadorVisible = false;
    },
    editDialogEvaluador(evaluador) {
      this.formEvaluador = JSON.parse(JSON.stringify(evaluador));
      this.editingEvaluador = true;
      this.dialogNewEvaluadorVisible = true;
    },
    deleteEvaluador(evaluador) {
      this.$confirm(
        this.$t("Esto borrará el evaluador. ¿Está seguro que desea continuar?"),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        const evaluatorIndex = this.risk.evaluadores.findIndex(
          (evaluator) => evaluator.id === evaluador.id
        );
        Vue.delete(this.risk.evaluadores, evaluatorIndex);
      });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    editEvaluador(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const index = this.risk.evaluadores.findIndex(
            (evaluador) => evaluador.id === this.formEvaluador.id
          );
          if (index !== -1) {
            this.risk.evaluadores[index] = this.formEvaluador;
            this.forceRerender();
            this.closeDialogEvaluador();
          }
        }
        return false;
      });
    },
    addEvaluador(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.formEvaluador.id = uuid();
          if (this.risk.evaluadores) {
            this.risk.evaluadores.push(this.formEvaluador);
          } else {
            this.risk.evaluadores = [];
            this.risk.evaluadores.push(this.formEvaluador);
          }

          this.closeDialogEvaluador();
          return;
        }
        return false;
      });
    },
  },
};
</script>

<style scoped>
h4 {
  font-weight: bold;
}
label {
  text-transform: uppercase;
  font-weight: bold;
  color: gray;
  font-size: 11px;
}
.info-txt {
  margin-top: 5px;
  color: #e65400;
}
.factores {
  font-size: 20px;
}
.align-center {
  text-align: center;
}

.subtitle {
  color: gray !important;
}
.margin-title {
  margin-top: 0px;
}
.button-disabled {
  background-color: lightgray !important;
}
.button-skip {
  margin-left: 10px;
}

.groupLabel {
  font-size: 15px;
  font-weight: bold;
  margin-left: 19px;
}
</style>
